const {
    GET_DETAILS_BY_MOBILENUMBER_SUCCESS,
    GET_DETAILS_BY_MOBILENUMBER_FAILURE,
  
    GET_CUSTOMER_BY_CIF_ID_SUCCESS,
    GET_CUSTOMER_BY_CIF_ID_FAILURE,
  } = require("../Constants");
  
  const initialState = {
    detailsByMobileNumber: {},
    customerByCifId: {},
    loading: null
  };
  
  function customerServiceReducer(state = initialState, action) {
    switch (action.type) {
      case GET_DETAILS_BY_MOBILENUMBER_SUCCESS:
        return {
          ...state,
          detailsByMobileNumber: action.payload,
        };
      case GET_DETAILS_BY_MOBILENUMBER_FAILURE:
        return {
          ...state,
          detailsByMobileNumber: action.payload,
        };
  
      case GET_CUSTOMER_BY_CIF_ID_SUCCESS:
        return {
          ...state,
          customerByCifId: action.payload,
        };
      case GET_CUSTOMER_BY_CIF_ID_FAILURE:
        return {
          ...state,
          customerByCifId: action.payload,
        };
  
      default:
        return state;
    }
  }
  
  export default customerServiceReducer;
  